import { makeStyles } from '@material-ui/core/styles';

export const useIssueContainerStyles = makeStyles((theme) => ({
  icon: {
    width: 40,
    height: 60,
    marginRight: 17,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
  },
  subtitle: {
    fontSize: 14,
  },
  container: {
    border: (props) => (props.mobile ? '1px solid #BCBCBCBC' : null),
    borderBottomStyle: 'none',
  },
  accordion: {
    '&.MuiAccordion-root.Mui-disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      borderRadius: 0,
    },
  },
  point: {
    color: theme.palette.primary.main,
    fontSize: 14,
    position: 'absolute',
    top: 0,
  },
}));
